<template>
  <section class="page page--container">
    <PageContent>
      <BusinessSignUpBlock />
    </PageContent>
  </section>
</template>

<script>
import { PageContent } from '@/components/molecules/PageContent'
import { BusinessSignUpBlock } from '@/components/molecules/BusinessSignUpBlock'

export default {
  name: 'BusinessRegisterPage',
  data() {},
  components: {
    PageContent,
    BusinessSignUpBlock
  }
}
</script>

<style scoped lang="scss"></style>
